import { WidgetSettings } from '@/types'
import { MenuType } from '../../types/widget'
import { safeFetchAPI, SafeFetchResponse } from '../index'
import { API_BASE } from './index'

type GetWidgetSettingsParams = {
  storeID?: string
  menuType?: MenuType | undefined
  merge?: boolean
  mergeUserSettings?: boolean
}

export async function getWidgetSettingsAPI(
  uid: string,
  menuType: MenuType,
  params?: GetWidgetSettingsParams
): Promise<SafeFetchResponse<WidgetSettings>> {
  const queryParams: Record<string, string | boolean> = {
    merge: params?.merge ?? true,
    mergeUserSettings: params?.mergeUserSettings ?? true,
  }
  if (params?.storeID) queryParams.storeID = params.storeID
  return safeFetchAPI<WidgetSettings>(`${API_BASE}/widget/settings/${uid}/${menuType}`, { queryParams })
}
